// VideoBackground.js
import React from 'react';
import styles from '../style/VideoBackground.module.scss';

const VideoBackground = () => {
  return (
    <div className={styles.videoBackground}>
      <video autoPlay muted loop className={styles.bgVideo}>
        <source src="Video/evas.website.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default VideoBackground;
